class BESSAppProjectEditorFilter extends BESSAppBase {

    constructor(editor, node, isValid) {
        super();
        this.editor = editor;
        this.valid = false;
        this.node = node;
        this.select = this.node.find('select');
        
        if (!isValid) {
            this.node.hide();
            return;
        }
        this.valid = true;
        this.node.show();        
        this.select.empty();

    }

    updateState() {
    }

    updateIsValid(isValid) {
        this.node.showIf(isValid);
        this.valid = true;
    }

    _addOptionToSelect(label, value) {
        let option = $('<option></option>');
        option.text(label);
        option.attr('value', value);
        this.select.append(option);
    }
}

class BESSAppProjectEditorAttributeFilter extends BESSAppProjectEditorFilter {

    constructor(editor, node, itemValues, attribute, label) {
        super(editor,
            node,
            itemValues.length > 1,
        );
        this.attribute = attribute;
        this.label = label;
        this.itemValues = itemValues;
        this.#createOption(null);

        _.each(itemValues, this.#createOption.bind(this));

        if(editor.filters[this.attribute] !== undefined) {
            this.select.val(editor.filters[this.attribute]);
        }

        this.select.unbind('change').change(function () {

            let selected = this.select.find(":selected").val();
            this.onSelected(parseInt(selected))
            this.node.addClassIf('active', selected > 0);

        }.bind(this));
    }

    undo() {
        this.onSelected(0);
    }

    #createOption(item, x) {
        if (item != null) {
            this._addOptionToSelect(item, (x + 1));
        } else {
            this._addOptionToSelect("Show all " + this.label, 'value', 0);
        }
    }

    onSelected(selected) {
        let value = null;
        let filterValue = null;
        if(selected > 0) {
            value = this.itemValues[selected-1];
            filterValue = this.select.find(":selected").val();
        }
        this.editor.filterByAttributeValue(this.attribute, value, filterValue)
    }
}